import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=12d163f2&scoped=true&"
var script = {}
import style0 from "./privacy.vue?vue&type=style&index=0&id=12d163f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d163f2",
  null
  
)

/* custom blocks */
import block0 from "./privacy.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports